export default "__VITE_ASSET__8b768c7d__"